import { render } from "./SignIn.vue?vue&type=template&id=4ff573c6"
import script from "./SignIn.vue?vue&type=script&lang=js"
export * from "./SignIn.vue?vue&type=script&lang=js"

import "./SignIn.vue?vue&type=style&index=0&id=4ff573c6&lang=scss"

import exportComponent from "C:\\Users\\oscar\\Documents\\GitHub\\ReSeT\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__